import { render, staticRenderFns } from "./activity-add-edit-question.vue?vue&type=template&id=dcf797ea&scoped=true&"
import script from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
export * from "./activity-add-edit-question.vue?vue&type=script&lang=js&"
import style0 from "./activity-add-edit-question.vue?vue&type=style&index=0&id=dcf797ea&scoped=true&lang=scss&"
import style1 from "./activity-add-edit-question.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf797ea",
  null
  
)

component.options.__file = "activity-add-edit-question.vue"
export default component.exports